<template>
  <div class="page flex-col justify-between">
    <div class="box_1 flex-col">
      <div class="section_1 flex-row">
        <img
          class="label_1"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png')"
        />
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG4724cd4fdb63b84c20b5fdc9c9238410.png')"
        />
        <span class="text_1">首页</span>
        <span class="text_2">解决方案</span>
        <span class="text_3">康复助手</span>
        <span class="text_4">产品介绍</span>
        <img
          class="thumbnail_1"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGa14a240930f6ce8957ded5645604cdd7.png')"
        />
        <span class="text_5">功能及报价</span>
        <span class="text_6">关于我们</span>
        <div class="group_1 flex-row">
          <span class="text_7">登录</span>
          <div class="block_1 flex-col"></div>
        </div>
      </div>
      <span class="paragraph_1">
        通用医疗
        <br />
        运动处方工作站
      </span>
      <div class="section_2 flex-row justify-between">
        <span class="text_8">专业的数字运动健康专家</span>
        <div class="block_2 flex-col justify-center align-center">
          <div class="text-wrapper_1 flex-col"><span class="text_9">体态精准识别</span></div>
        </div>
      </div>
      <span class="text_10">professional&nbsp;digital&nbsp;sports&nbsp;health&nbsp;expert</span>
      <div class="section_3 flex-col justify-center align-center">
        <div class="text-wrapper_2 flex-col"><span class="text_11">跌倒风险评估</span></div>
      </div>
      <div class="section_4 flex-col justify-center align-center">
        <div class="text-wrapper_3 flex-col"><span class="text_12">检测评估干预</span></div>
      </div>
      <div class="section_5 flex-col justify-center align-center">
        <div class="text-wrapper_4 flex-col"><span class="text_13">个性运动处方</span></div>
      </div>
      <div class="section_6 flex-col"></div>
      <div class="section_7 flex-col"></div>
      <img
        class="image_2"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNG4a8a7e516b2af0f4fdd998d0ce5bb871.png')"
      />
      <div class="text-wrapper_5 flex-col">
        <span class="text_14">运动处方系统及本地化工作站</span>
        <span class="text_15">功复道&nbsp;&nbsp;&nbsp;PF-E26</span>
        <span class="text_16">健康体适能测评仪</span>
        <span class="text_17">人体成分分析仪</span>
        <span class="text_18">全身有氧训练机（前摆臂）IC7006</span>
        <span class="text_19">全身线性有氧健身机&nbsp;IC7007</span>
        <span class="text_20">全身脑部肢体协调训练机&nbsp;IC7009</span>
      </div>
    </div>
    <div class="box_2 flex-col">
      <div class="image-wrapper_1 flex-row justify-between">
        <img
          class="label_2"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png')"
        />
        <img
          class="image_3"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG33f935e7aff511ef96bc22348410d09b.png')"
        />
      </div>
      <div class="section_8 flex-row">
        <div class="group_2 flex-col justify-between">
          <div class="text-wrapper_6 flex-row justify-between">
            <span class="text_21">联系方式：13220190868</span>
            <span class="text_22">Email：info&#64;ktangtang.com</span>
          </div>
          <span class="text_23">官网地址：https://ktangtang.com</span>
          <span class="text_24">公司地址：&nbsp;北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
        </div>
        <div class="text-wrapper_7 flex-col justify-between">
          <span class="text_25">公众号：以动健康</span>
          <span class="text_26">官方微博：&#64;以动健康</span>
          <span class="text_27">京ICP备19026627号</span>
        </div>
        <div class="image-text_1 flex-col justify-between">
          <img
            class="image_4"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGb44291ba8e983b81bea2ee1b1a2e5ed9.png')"
          />
          <span class="text-group_1">公众号二维码</span>
        </div>
      </div>
    </div>
    <div class="box_3 flex-col">
      <div class="group_3 flex-row">
        <div class="group_4 flex-col"></div>
        <div class="group_5 flex-col"></div>
        <div class="group_6 flex-col"></div>
        <div class="group_7 flex-col"></div>
        <img
          class="thumbnail_2"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
        />
        <img
          class="thumbnail_3"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
        />
        <img
          class="thumbnail_4"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
        />
        <span class="text_28">功能康复评估</span>
      </div>
      <div class="group_8 flex-col">
        <div class="box_4 flex-row justify-between">
          <div class="image-wrapper_2 flex-col">
            <img
              class="image_5"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG697eda4258e5577b574e3db6de7fc8a9.png')"
            />
          </div>
          <div class="group_9 flex-col justify-between">
            <div class="group_10 flex-row justify-between">
              <div class="group_11 flex-row">
                <div class="text-group_2 flex-col justify-between">
                  <span class="text_29">优势</span>
                  <span class="text_30">01</span>
                </div>
              </div>
              <div class="text-wrapper_8 flex-col">
                <span class="text_31">50+</span>
                <span class="text_32">骨科、三高慢性病的康复计划库</span>
              </div>
              <img
                class="label_3"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG6d71c1808137118b0f5bcad33d328db0.png')"
              />
            </div>
            <div class="group_12 flex-row justify-between">
              <div class="text-wrapper_9 flex-col">
                <span class="text_33">200</span>
                <span class="text_34">骨特殊实验评估和问卷评估库</span>
              </div>
              <div class="block_3 flex-row">
                <div class="text-group_3 flex-col justify-between">
                  <span class="text_35">优势</span>
                  <span class="text_36">02</span>
                </div>
              </div>
              <img
                class="label_4"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG7da252a788542e7d11e602376960b89e.png')"
              />
            </div>
            <div class="group_13 flex-row justify-between">
              <div class="block_4 flex-row">
                <div class="text-group_4 flex-col justify-between">
                  <span class="text_37">优势</span>
                  <span class="text_38">03</span>
                </div>
              </div>
              <div class="text-wrapper_10 flex-col">
                <span class="text_39">3000+</span>
                <span class="text_40">运动方式运动处方库</span>
              </div>
              <img
                class="label_5"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG6d71c1808137118b0f5bcad33d328db0.png')"
              />
            </div>
            <div class="group_14 flex-row justify-between">
              <div class="text-wrapper_11 flex-col">
                <span class="text_41">康复训练</span>
                <span class="text_42">徒手及设备训练方法推荐</span>
              </div>
              <div class="group_15 flex-row">
                <div class="text-group_5 flex-col justify-between">
                  <span class="text_43">优势</span>
                  <span class="text_44">04</span>
                </div>
              </div>
              <img
                class="label_6"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG7da252a788542e7d11e602376960b89e.png')"
              />
            </div>
            <div class="group_16 flex-row justify-between">
              <div class="block_5 flex-row">
                <div class="text-group_6 flex-col justify-between">
                  <span class="text_45">优势</span>
                  <span class="text_46">05</span>
                </div>
              </div>
              <div class="text-wrapper_12 flex-col">
                <span class="text_47">居家康复</span>
                <span class="paragraph_2">
                  发送运动康复计划到患者手机，
                  <br />
                  远程康复管理，管理智能康复设备
                </span>
              </div>
              <img
                class="label_7"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG6d71c1808137118b0f5bcad33d328db0.png')"
              />
            </div>
          </div>
        </div>
        <div class="box_5 flex-row justify-between">
          <div class="text-wrapper_13 flex-col">
            <span class="text_48">信息化平台</span>
            <span class="paragraph_3">
              康复设备中心数字化康复中心信息化
              <br />
              平台，管理物联网康复设备
            </span>
          </div>
          <div class="block_6 flex-row">
            <div class="text-group_7 flex-col justify-between">
              <span class="text_49">优势</span>
              <span class="text_50">06</span>
            </div>
          </div>
          <img
            class="label_8"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG7da252a788542e7d11e602376960b89e.png')"
          />
        </div>
      </div>
      <div class="group_17 flex-row">
        <div class="section_9 flex-col"></div>
        <div class="section_10 flex-col"></div>
        <div class="section_11 flex-col"></div>
        <div class="section_12 flex-col"></div>
        <img
          class="thumbnail_5"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
        />
        <img
          class="thumbnail_6"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
        />
        <img
          class="thumbnail_7"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
        />
        <span class="text_51">测试项目中老年模式</span>
      </div>
      <div class="group_18 flex-row justify-between">
        <div class="group_19 flex-row">
          <span class="text_52">三米折返走</span>
          <div class="group_20 flex-col"><div class="section_13 flex-col"></div></div>
          <div class="group_21 flex-col">
            <div class="box_6 flex-col"></div>
            <div class="box_7 flex-col"></div>
            <div class="box_8 flex-col"></div>
          </div>
          <div class="group_22 flex-col"></div>
          <div class="group_23 flex-col">
            <div class="block_7 flex-col"></div>
            <div class="block_8 flex-col"></div>
          </div>
          <div class="group_24 flex-col"><div class="group_25 flex-col"></div></div>
        </div>
        <div class="group_26 flex-row">
          <span class="paragraph_4">
            原地踏步心肺
            <br />
            耐力测试
          </span>
          <div class="block_9 flex-col"><div class="section_14 flex-col"></div></div>
          <div class="block_10 flex-col"></div>
          <div class="block_11 flex-col"><div class="section_15 flex-col"></div></div>
          <div class="block_12 flex-col"></div>
        </div>
        <div class="text-wrapper_14 flex-col"><span class="text_53">睁眼单腿站立</span></div>
      </div>
      <div class="group_27 flex-row justify-between">
        <div class="group_28 flex-row">
          <span class="paragraph_5">
            站立位双臂
            <br />
            平举体前屈实验
          </span>
          <div class="block_13 flex-col justify-between">
            <div class="section_16 flex-col">
              <div class="box_9 flex-col"></div>
              <div class="box_10 flex-col">
                <div class="block_14 flex-col">
                  <div class="group_29 flex-col">
                    <div class="section_17 flex-col"><div class="group_30 flex-col"></div></div>
                  </div>
                </div>
                <div class="block_15 flex-col"></div>
              </div>
            </div>
            <div class="section_18 flex-row justify-between">
              <div class="group_31 flex-col"></div>
              <div class="group_32 flex-col"><div class="group_33 flex-col"></div></div>
            </div>
          </div>
          <div class="image-wrapper_3 flex-col">
            <img
              class="thumbnail_8"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNGde595e8f28cbd3855f4739adb10e988f.png')"
            />
          </div>
          <div class="block_16 flex-col"><div class="group_34 flex-col"></div></div>
          <div class="block_17 flex-col">
            <div class="block_18 flex-col"></div>
            <div class="block_19 flex-col"></div>
          </div>
          <img
            class="image_6"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGc3734c5c54373d5a377b5d74d4bbf7d4.png')"
          />
          <div class="block_20 flex-col"><div class="group_35 flex-col"></div></div>
          <img
            class="thumbnail_9"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG8ecbe8bac6216cfb95cd86c9e426a32d.png')"
          />
        </div>
        <div class="group_36 flex-col">
          <div class="image-wrapper_4 flex-row">
            <img
              class="label_9"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG6ae25ed7ec1b8273c928751d2032565f.png')"
            />
          </div>
          <div class="section_19 flex-row"><div class="section_20 flex-col"></div></div>
          <div class="section_21 flex-row justify-between">
            <span class="text_54">坐位起立实验</span>
            <div class="image-wrapper_5 flex-col">
              <img
                class="label_10"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG30540f603366d840c5be02d5298b74a5.png')"
              />
            </div>
          </div>
          <div class="section_22 flex-col">
            <div class="group_37 flex-col"></div>
            <div class="group_38 flex-col">
              <div class="section_23 flex-col"><div class="box_11 flex-col"></div></div>
            </div>
          </div>
          <div class="section_24 flex-col"><div class="box_12 flex-col"></div></div>
          <div class="image-wrapper_6 flex-col">
            <img
              class="label_11"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG67b77324c8adb95f67cf3e414a95ac88.png')"
            />
          </div>
          <div class="section_25 flex-col">
            <div class="section_26 flex-col">
              <div class="block_21 flex-col"><div class="group_39 flex-col"></div></div>
              <div class="block_22 flex-col"></div>
            </div>
          </div>
          <div class="section_27 flex-col">
            <div class="image-wrapper_7 flex-col">
              <img
                class="image_7"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG70a1afb880b656c4ea58881ccdc07ce6.png')"
              />
            </div>
          </div>
        </div>
        <div class="group_40 flex-col">
          <div class="block_23 flex-row justify-between">
            <div class="box_13 flex-col"></div>
            <div class="box_14 flex-col">
              <img
                class="image_8"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG6f2f6c8c6799673b03ae3d27094d0448.png')"
              />
              <div class="image-wrapper_8 flex-col">
                <img
                  class="thumbnail_10"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG71bb51b56af3092a8e3ccfdb71fd6c25.png')"
                />
              </div>
            </div>
          </div>
          <div class="block_24 flex-row">
            <span class="text_55">五次坐站实验</span>
            <img
              class="label_12"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG24544bf989a6bf403194eb9bfb9c2588.png')"
            />
            <div class="block_25 flex-col justify-between">
              <img
                class="image_9"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNGba8f1a021d2be3b7cb3278ef0350a340.png')"
              />
              <div class="box_15 flex-col"></div>
            </div>
            <div class="image-wrapper_9 flex-col justify-between">
              <img
                class="image_10"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG730e6c96c1e84b5a6086ab9698c616f5.png')"
              />
              <img
                class="thumbnail_11"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG73830acb6fc36e91fb2292f4e478f8ac.png')"
              />
            </div>
            <img
              class="image_11"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNGf7a9ca843a7315cd512e47f139d210ca.png')"
            />
            <img
              class="image_12"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNGc13c119ca7417b4cf13ec9f6c617bd0a.png')"
            />
          </div>
          <div class="block_26 flex-col">
            <div class="group_41 flex-col"></div>
            <img
              class="image_13"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG3743c1c855d9844f1760a6653333c7df.png')"
            />
            <img
              class="image_14"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNGb0228b772946876341a48a9148598a90.png')"
            />
            <img
              class="image_15"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9f718998ce2a59556d705dd262689c16.png')"
            />
            <div class="group_42 flex-col"></div>
            <div class="image-wrapper_10 flex-col">
              <img
                class="label_13"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNGce4cdb516343e47d5f042c8738a08844.png')"
              />
            </div>
            <img
              class="image_16"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNGd9b0f55d25a21909dbb05f520279d0ce.png')"
            />
            <img
              class="thumbnail_12"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG2d60fe3b512cebe056875165ba626aaf.png')"
            />
          </div>
          <img
            class="image_17"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG72d9aec6c80b883492c92876e30c81ac.png')"
          />
          <img
            class="label_14"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGf1687c0f913f45fc71ece7246677cd40.png')"
          />
          <div class="block_27 flex-col">
            <div class="section_28 flex-row"><div class="group_43 flex-col"></div></div>
            <div class="section_29 flex-row"><div class="box_16 flex-col"></div></div>
            <div class="section_30 flex-col">
              <div class="image-wrapper_11 flex-col">
                <img
                  class="thumbnail_13"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG757cd0083409ea13674fbadc3f563b7c.png')"
                />
              </div>
              <div class="image-wrapper_12 flex-col">
                <img
                  class="thumbnail_14"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG5d59ca5de873055e54b92fe1fcb32711.png')"
                />
              </div>
            </div>
            <div class="section_31 flex-col"><div class="box_17 flex-col"></div></div>
            <div class="section_32 flex-col"><div class="box_18 flex-col"></div></div>
            <div class="section_33 flex-col">
              <div class="image-wrapper_13 flex-col">
                <img
                  class="image_18"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG6d98f84cef866c70508fbe39bcaae150.png')"
                />
              </div>
            </div>
            <div class="image-wrapper_14 flex-col">
              <img
                class="image_19"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG75523258d49712cbd7aa5ba4c604fd03.png')"
              />
              <img
                class="thumbnail_15"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG1749a23bae0d9f500cd26144152bdeb5.png')"
              />
            </div>
            <div class="image-wrapper_15 flex-col">
              <img
                class="image_20"
                referrerpolicy="no-referrer"
                v-lazy="require('./assets/img/FigmaDDSSlicePNG62574c49087e9cc64ba1a9934f643d85.png')"
              />
            </div>
          </div>
          <div class="block_28 flex-col">
            <div class="section_34 flex-col"><div class="box_19 flex-col"></div></div>
          </div>
          <div class="block_29 flex-col">
            <div class="group_44 flex-col"><div class="section_35 flex-col"></div></div>
          </div>
          <img
            class="image_21"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG68bc204ee2a1b2020eb5e642be23ea30.png')"
          />
          <div class="block_30 flex-col">
            <div class="group_45 flex-col"><div class="block_31 flex-col"></div></div>
          </div>
          <img
            class="image_22"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG5ffe7dc1a5ff4d2461e762b957156c6b.png')"
          />
          <img
            class="image_23"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNG86016a9a42a0d9c0f19c163be4526094.png')"
          />
          <div class="block_32 flex-col">
            <div class="box_20 flex-col">
              <div class="box_21 flex-col"><div class="block_33 flex-col"></div></div>
              <div class="box_22 flex-col"></div>
              <div class="box_23 flex-col"></div>
            </div>
            <div class="box_24 flex-col">
              <div class="image-wrapper_16 flex-col">
                <img
                  class="thumbnail_16"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG57c80b27312fe646de129c3e5c939e02.png')"
                />
              </div>
              <div class="group_46 flex-col">
                <div class="image-wrapper_17 flex-col">
                  <img
                    class="thumbnail_17"
                    referrerpolicy="no-referrer"
                    v-lazy="require('./assets/img/FigmaDDSSlicePNG57601ab53c2f074840621dedaec4a0fc.png')"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="block_34 flex-col"><div class="group_47 flex-col"></div></div>
          <div class="block_35 flex-col"><div class="group_48 flex-col"></div></div>
          <div class="image-wrapper_18 flex-col">
            <img
              class="image_24"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG4ff9fde4eeacc98ed16e67d52f68203b.png')"
            />
          </div>
        </div>
      </div>
      <div class="group_49 flex-row">
        <div class="section_36 flex-col"></div>
        <div class="section_37 flex-col"></div>
        <div class="section_38 flex-col"></div>
        <div class="section_39 flex-col"></div>
        <img
          class="thumbnail_18"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
        />
        <img
          class="thumbnail_19"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
        />
        <img
          class="thumbnail_20"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
        />
        <span class="text_56">规格参数</span>
      </div>
      <span class="paragraph_6">
        外观尺寸:&nbsp;&nbsp;(170+60)&nbsp;cm&nbsp;x85cmx234cm&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CPU:&nbsp;&nbsp;Intel&nbsp;i7-7567U&nbsp;3.5GHz&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;NVIDIA&nbsp;GPU:&nbsp;&nbsp;GEFORCE&nbsp;GTX1050
        <br />
        内存:&nbsp;8G&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;硬盘:&nbsp;固态256G&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;操作系统:&nbsp;&nbsp;Windows10&nbsp;x64&nbsp;专业版&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <br />
        3D动作捕捉摄像头:&nbsp;&nbsp;Astra&nbsp;Pro&nbsp;NL/Azure&nbsp;inect&nbsp;DK
      </span>
      <img
        class="image_25"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNGa1d709c619b00914290a602802ddc97f.png')"
      />
      <div class="group_50 flex-row justify-between">
        <img
          class="image_26"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGef90c59acbe218cca63ff99b7ad97664.png')"
        />
        <div class="section_40 flex-col">
          <div class="image-wrapper_19 flex-col">
            <img
              class="image_27"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9e6b1607d84622bc32c89ab002e7a44e.png')"
            />
          </div>
        </div>
        <div class="image-wrapper_20 flex-row">
          <img
            class="image_28"
            referrerpolicy="no-referrer"
            :v-lazy=item.lanhuimage0"
            v-for="(item, index) in loopData0"
            :key="index"
          />
        </div>
      </div>
      <div class="group_51 flex-row">
        <div class="group_52 flex-col"></div>
        <div class="group_53 flex-col"></div>
        <div class="group_54 flex-col"></div>
        <div class="group_55 flex-col"></div>
        <div class="group_56 flex-col"></div>
        <div class="group_57 flex-col"></div>
        <div class="group_58 flex-col"></div>
        <div class="group_59 flex-col"></div>
      </div>
      <div class="group_60 flex-col">
        <div class="box_25 flex-row justify-between">
          <div class="group_61 flex-col"></div>
          <span class="text_57">硬件特点</span>
          <div class="group_62 flex-col"></div>
        </div>
        <div class="box_26 flex-row justify-between">
          <div class="image-text_2 flex-col justify-between">
            <div class="block_36 flex-col">
              <div class="box_27 flex-row">
                <span class="text_58">肩关节</span>
                <img
                  class="thumbnail_21"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG81bb5ad478617eaf4eca1ca1f13fed22.png')"
                />
                <img
                  class="thumbnail_22"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG81bb5ad478617eaf4eca1ca1f13fed22.png')"
                />
                <span class="text_59">颈关节</span>
                <img
                  class="image_29"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG76469e35ca137416885a3f92b9f1e505.png')"
                />
                <img
                  class="image_30"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG76469e35ca137416885a3f92b9f1e505.png')"
                />
              </div>
              <div class="box_28 flex-row">
                <div class="group_63 flex-col">
                  <div class="box_29 flex-row">
                    <span class="text_60">髋关节</span>
                    <img
                      class="image_31"
                      referrerpolicy="no-referrer"
                      v-lazy="require('./assets/img/FigmaDDSSlicePNG76469e35ca137416885a3f92b9f1e505.png')"
                    />
                  </div>
                  <div class="box_30 flex-row justify-between">
                    <div class="block_37 flex-row">
                      <span class="text_61">肘关节</span>
                      <img
                        class="image_32"
                        referrerpolicy="no-referrer"
                        v-lazy="require('./assets/img/FigmaDDSSlicePNG76469e35ca137416885a3f92b9f1e505.png')"
                      />
                    </div>
                    <div class="block_38 flex-col"></div>
                    <div class="block_39 flex-col justify-between">
                      <div class="section_41 flex-row">
                        <img
                          class="thumbnail_23"
                          referrerpolicy="no-referrer"
                          v-lazy="require('./assets/img/FigmaDDSSlicePNG81bb5ad478617eaf4eca1ca1f13fed22.png')"
                        />
                        <div class="section_42 flex-col"><div class="box_31 flex-col"></div></div>
                      </div>
                      <div class="section_43 flex-col">
                        <div class="box_32 flex-col"></div>
                        <div class="box_33 flex-col"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  class="thumbnail_24"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG128725edcb1fe55d364ab943274e9543.png')"
                />
                <img
                  class="thumbnail_25"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNGec968a80b57332c804c05807a7ef2790.png')"
                />
                <div class="group_64 flex-col">
                  <div class="group_65 flex-row">
                    <div class="group_66 flex-col">
                      <div class="group_67 flex-col"></div>
                      <div class="group_68 flex-col"></div>
                    </div>
                    <span class="text_62">腰关节</span>
                    <img
                      class="image_33"
                      referrerpolicy="no-referrer"
                      v-lazy=zy="./assets/img/FigmaDDSSlicePNG76469e35ca137416885a3f92b9f1e505.png"
                    />
                  </div>
                  <div class="group_69 flex-row justify-end">
                    <div class="block_40 flex-col justify-between">
                      <div class="box_34 flex-col">
                        <div class="group_70 flex-col"></div>
                        <div class="group_71 flex-col"></div>
                      </div>
                      <div class="box_35 flex-col">
                        <div class="group_72 flex-col"></div>
                        <div class="group_73 flex-col"></div>
                      </div>
                    </div>
                    <div class="block_41 flex-row">
                      <span class="text_63">腕关节</span>
                      <img
                        class="image_34"
                        referrerpolicy="no-referrer"
                        v-lazy="require('./assets/img/FigmaDDSSlicePNG76469e35ca137416885a3f92b9f1e505.png')"
                      />
                    </div>
                    <div class="image-wrapper_21 flex-col justify-between">
                      <img
                        class="thumbnail_26"
                        referrerpolicy="no-referrer"
                        v-lazy="require('./assets/img/FigmaDDSSlicePNG81bb5ad478617eaf4eca1ca1f13fed22.png')"
                      />
                      <img
                        class="thumbnail_27"
                        referrerpolicy="no-referrer"
                        v-lazy="require('./assets/img/FigmaDDSSlicePNGca3121319c83980456f03819f44c3ace.png')"
                      />
                    </div>
                  </div>
                  <div class="group_74 flex-row">
                    <span class="text_64">指关节</span>
                    <img
                      class="image_35"
                      referrerpolicy="no-referrer"
                      v-lazy="require('./assets/img/FigmaDDSSlicePNG76469e35ca137416885a3f92b9f1e505.png')"
                    />
                  </div>
                </div>
              </div>
              <div class="image-wrapper_22 flex-row">
                <img
                  class="thumbnail_28"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG128725edcb1fe55d364ab943274e9543.png')"
                />
              </div>
              <div class="box_36 flex-row">
                <div class="block_42 flex-col justify-between">
                  <div class="section_44 flex-row">
                    <span class="text_65">踝关节</span>
                    <img
                      class="image_36"
                      referrerpolicy="no-referrer"
                      v-lazy="require('./assets/img/FigmaDDSSlicePNG76469e35ca137416885a3f92b9f1e505.png')"
                    />
                  </div>
                  <div class="section_45 flex-row justify-between">
                    <div class="section_46 flex-col"></div>
                    <div class="section_47 flex-col"><div class="group_75 flex-col"></div></div>
                  </div>
                </div>
                <img
                  class="thumbnail_29"
                  referrerpolicy="no-referrer"
                  v-lazy="require('./assets/img/FigmaDDSSlicePNG128725edcb1fe55d364ab943274e9543.png')"
                />
                <div class="block_43 flex-row">
                  <span class="text_66">膝关节</span>
                  <img
                    class="image_37"
                    referrerpolicy="no-referrer"
                    v-lazy="require('./assets/img/FigmaDDSSlicePNG76469e35ca137416885a3f92b9f1e505.png')"
                  />
                </div>
              </div>
              <div class="box_37 flex-col">
                <div class="block_44 flex-col"></div>
                <div class="block_45 flex-col"></div>
              </div>
              <div class="box_38 flex-col">
                <div class="block_46 flex-col"></div>
                <div class="block_47 flex-col"></div>
              </div>
              <div class="box_39 flex-col">
                <div class="box_40 flex-col"></div>
                <div class="box_41 flex-col"></div>
              </div>
            </div>
            <span class="text-group_8">
              将精准运动检测技术与运动医学、健康科学相结合，基于&nbsp;AI&nbsp;芯片的体形&nbsp;3D&nbsp;重构
            </span>
          </div>
          <div class="image-text_3 flex-col justify-between">
            <img
              class="image_38"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG291cc0fbf99e0a6baca351c026dc8a9a.png')"
            />
            <span class="text-group_9">
              创新图像识别算法，并通过持续的机器学习和神经元网络计算技术，实现运动姿态的精准识别以及康复训练；
            </span>
          </div>
        </div>
      </div>
      <div class="group_76 flex-col"></div>
      <div class="group_77 flex-col">
        <div class="group_78 flex-row justify-between">
          <div class="group_79 flex-col"></div>
          <div class="group_80 flex-col"></div>
        </div>
        <div class="group_81 flex-col"></div>
        <div class="group_82 flex-col"></div>
      </div>
      <img
        class="image_39"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNG22503260fe4e62e92a2e118653ab7706.png')"
      />
      <div class="group_83 flex-col">
        <div class="group_84 flex-col"><div class="section_48 flex-col"></div></div>
      </div>
      <img
        class="image_40"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNG404bbd0916adae54f43a193c6bd40826.png')"
      />
      <div class="group_85 flex-col align-center"><div class="section_49 flex-col"></div></div>
      <div class="group_86 flex-col"><div class="box_42 flex-col"></div></div>
      <div class="group_87 flex-col"><div class="box_43 flex-col"></div></div>
      <div class="group_88 flex-col"></div>
      <div class="group_89 flex-col">
        <div class="block_48 flex-col"><div class="group_90 flex-col"></div></div>
      </div>
      <div class="group_91 flex-col"><div class="section_50 flex-col"></div></div>
      <div class="group_92 flex-col">
        <div class="group_93 flex-col"></div>
        <div class="group_94 flex-col"><div class="section_51 flex-col"></div></div>
      </div>
      <div class="group_95 flex-col">
        <img
          class="label_15"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG289148c8bad54b314a5ddfd97945a8ea.png')"
        />
        <div class="section_52 flex-col"></div>
      </div>
      <div class="group_96 flex-col">
        <div class="box_44 flex-col">
          <div class="group_97 flex-col"></div>
          <div class="group_98 flex-col"></div>
        </div>
      </div>
      <div class="group_99 flex-col"></div>
      <div class="image-wrapper_23 flex-col">
        <img
          class="image_41"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG6ee7e30246e64e314b64377e420857da.png')"
        />
      </div>
      <img
        class="label_16"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNGf6442e398fe14e8bd78078425e45cd43.png')"
      />
      <img
        class="image_42"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNGa54554c0fcb164671e7970adfc280ca8.png')"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loopData0: [
        {
          lanhuimage0: 'https://lanhu.oss-cn-beijing.aliyuncs.com/FigmaDDSSlicePNGa1c63be730897713032983e7287004e9.png'
        },
        {
          lanhuimage0: 'https://lanhu.oss-cn-beijing.aliyuncs.com/FigmaDDSSlicePNGdc8febba2c72d746d86dc36969c9f626.png'
        },
        {
          lanhuimage0: 'https://lanhu.oss-cn-beijing.aliyuncs.com/FigmaDDSSlicePNG9f92dd01ef288e7476c5f393580ecbc7.png'
        },
        {
          lanhuimage0: 'https://lanhu.oss-cn-beijing.aliyuncs.com/FigmaDDSSlicePNG00226ea9b36f96d8b5f76e19e50a1867.png'
        },
        {
          lanhuimage0: 'https://lanhu.oss-cn-beijing.aliyuncs.com/FigmaDDSSlicePNG4562632520a33289a2a20a5b365ef6b5.png'
        },
        {
          lanhuimage0: 'https://lanhu.oss-cn-beijing.aliyuncs.com/FigmaDDSSlicePNGf95579cb1824609824cd748de7d8361f.png'
        }
      ],
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />